import React, { useEffect, useState } from "react";
import { Modal, Pressable, StyleSheet, Text, View } from "react-native";
import { CategoryPicker } from "./CategoryPicker";
import { behavioralToPickerId } from "../lockbox/utils/categoryPickerCatalog.js";

/**
 * Step through distracting apps one-by-one (Review Each).
 *
 * @param {{
 *   visible: boolean,
 *   apps: import('../lockbox/domain/types.js').LockboxAppEntity[],
 *   onClose: () => void,
 *   onSaveApp: (app: import('../lockbox/domain/types.js').LockboxAppEntity, opts: { pickerCategoryId: string, disturbing: boolean, blockInMode: boolean }) => void | Promise<void>,
 * }} props
 */
export function AppReviewWizard({ visible, apps, onClose, onSaveApp }) {
  const [index, setIndex] = useState(0);
  const [pickerCategoryId, setPickerCategoryId] = useState("other");
  const [disturbing, setDisturbing] = useState(false);

  const app = apps[index];
  const total = apps.length;

  useEffect(() => {
    if (!visible || !app) return;
    setIndex(0);
    setPickerCategoryId(behavioralToPickerId(app.classification?.primaryCategory || "unknown"));
    setDisturbing(!!app.classification?.userFlaggedSeverity);
  }, [visible]);

  useEffect(() => {
    if (!app) return;
    setPickerCategoryId(behavioralToPickerId(app.classification?.primaryCategory || "unknown"));
    setDisturbing(!!app.classification?.userFlaggedSeverity);
  }, [app?.id, index]);

  if (!visible || !app) return null;

  const goNext = () => {
    if (index + 1 >= total) onClose();
    else setIndex((i) => i + 1);
  };

  const finishStep = async (blockInMode) => {
    await onSaveApp(app, { pickerCategoryId, disturbing, blockInMode });
    goNext();
  };

  return (
    <Modal visible={visible} animationType="slide" onRequestClose={onClose}>
      <View style={styles.sheet}>
        <Text style={styles.progress}>
          Review {index + 1} of {total}
        </Text>
        <Text style={styles.appName}>{app.displayName}</Text>
        {app.packageName ? <Text style={styles.pkg}>{app.packageName}</Text> : null}

        <CategoryPicker
          detectedCategory={app.classification?.primaryCategory || "unknown"}
          pickerCategoryId={pickerCategoryId}
          onPickerCategoryChange={setPickerCategoryId}
          disturbing={disturbing}
          onDisturbingChange={setDisturbing}
        />

        <Pressable style={styles.blockBtn} onPress={() => void finishStep(true)}>
          <Text style={styles.blockBtnText}>Block in this mode</Text>
        </Pressable>
        <Pressable style={styles.allowBtn} onPress={() => void finishStep(false)}>
          <Text style={styles.allowBtnText}>Keep allowed</Text>
        </Pressable>
        <Pressable style={styles.skipBtn} onPress={goNext}>
          <Text style={styles.skipText}>Skip</Text>
        </Pressable>
        <Pressable style={styles.closeBtn} onPress={onClose}>
          <Text style={styles.closeText}>Cancel review</Text>
        </Pressable>
      </View>
    </Modal>
  );
}
